import React from 'react';
import PropTypes from 'prop-types';

const MaintenanceHandler = ({ active, message, children }) => {
  return active ? (
    <div className="MaintenanceHandler">
      <div
        className="MaintenanceHandler__message"
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </div>
  ) : (
    children
  );
};

MaintenanceHandler.propTypes = {
  message: PropTypes.string,
  active: PropTypes.bool,
};

export default MaintenanceHandler;
